export class Constants {
    public static CUSTOMER_REPORTS_HEADER_OPTION = {
        isHamburger: false,
        isSearch: false,
        isNotification: false,
        isOtherMenu: false
    }
    public static ALERT_TYPE = {
        'success': 'alert alert-success',
        'danger': 'alert alert-danger',
        'info': 'alert alert-info',
        'warning': 'alert alert-warning'
    }

    public static bDeleted = {
        True: true,
        False: false
    }

    //user
    public static  UserRoleID = {
        SuperUser: 0,
        AdminUser: 1,
        User: 2
    }

    public static  UserRoleName = {
        SuperUser: "Super User",
        AdminUser: "Admin User",
        User: "User"
    }

    public static  Date = {
        MinValue: "01/01/0001"
    }

    //clinic
    public static  Clinic = {
        AdminClinic: 1
    }

    public static DefaultValues = {
        DropDownValue: "<All>",
        LocationName: "Default"
    }

    public static bDefault = {
        True: 1,
        False: 0
    }

    //equipment
    public static EquipmentName = {
        Default: "TOTAL BRAIN & BODY O2"
    }

    //machine
    public static MachineStatus = {
        Active: "Active",
        Inactive: "Inactive",
    }

    //reports
    public static Reports = {
        MinVal: 3,
        MaxVal: 20,
    }
    public static PatientRefOffset = 100000;
}
